import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/data.service';
import { TriageUserDataService } from '../../services/triage-user-data.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-symptom-assessment-symptoms',
  imports: [ReactiveFormsModule, NzCheckboxModule, NzFormModule, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './symptom-assessment-symptoms.component.html',
  styleUrls: ['./symptom-assessment-symptoms.component.scss'],
})
export class SymptomAssessmentSymptomsComponent implements OnInit, OnDestroy {
  symptoms: any[] = [];
  previousSelection: string[] = [];
  filteredSymptoms: any[] = [...this.symptoms];
  symptomsForm!: FormGroup;
  searchValues = {
    commonInput: {
      control: new FormControl(''),
    },
  };
  sessionId: string = '';
  @Output() emitSymptom: EventEmitter<any> = new EventEmitter<any>();

  private searchSubscription!: Subscription;

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private dataService: DataService,
    private triageUserDataService: TriageUserDataService
  ) {}

  ngOnInit(): void {
    this.getSymptoms();
  }

  private getSymptoms() {
    this.dataService.getSessionId().subscribe((res: string) => {
      this.sessionId = res;
    });

    this.symptoms = this.triageUserDataService.get('symptoms') || [];

    this.symptomsForm = this.fb.group(
      this.symptoms.reduce(
        (controls, symptom) => {
          controls[symptom.label] = new FormControl(false);
          return controls;
        },
        {} as { [key: string]: FormControl }
      )
    );

    this.filteredSymptoms = [...this.symptoms];

    this.searchSubscription = this.searchValues.commonInput.control.valueChanges.subscribe((searchTerm: string | null) => {
      if (searchTerm) {
        this.filteredSymptoms = this.symptoms.filter((symptom) => symptom.label.toLowerCase().includes(searchTerm.toLowerCase()));
      } else {
        this.filteredSymptoms = [...this.symptoms];
      }
      this.cdr.detectChanges();
    });

    this.symptomsForm.valueChanges.subscribe((values) => {
      let selectedLabels = Object.keys(values).filter((key) => values[key]);
      const lastSelected = selectedLabels.find((label) => !this.previousSelection.includes(label)) || selectedLabels[0];
      if (selectedLabels.length > 1) {
        Object.keys(values).forEach((key) => {
          this.symptomsForm.controls[key].setValue(key === lastSelected, { emitEvent: false });
        });

        this.previousSelection = [lastSelected];
        this.cdr.detectChanges();
      } else {
        this.previousSelection = selectedLabels;
      }
      const selectedSymptom = this.symptoms.find((symptom) => symptom.label === lastSelected);
      this.emitSymptom.emit(selectedSymptom || null);
    });
  }

  ngOnDestroy(): void {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }
}
